<template>
    <div>
        <div ref="box" class="vl-box" :style="{ height: height + 'px' }">
            <div :style="{ height: boxHeight + 'px' }" >
                <div
                    class="vl-box-item"
                    :style="{
                        height: rowHeight + 'px',
                        lineHeight: rowHeight + 'px',
                        top: (index + offsetIndex) * rowHeight + 'px'
                    }"
                    v-for="(item,index) in offsetData"
                    :key="index"
                    :data-index="item.nodeIndex"
                    :class="{'active_item': currentIndex >= item.nodeIndex}"
                    @click="jumpNodeIndex(item.nodeIndex)"
                >
                    <div style="min-width:166px;">时间: {{item.time}}</div>
                    <div style="min-width:223px;">经度:{{ item.point[0] }} 纬度:{{item.point[1]}}</div>
                    <div style="min-width:92px;">设备状态: 在线</div>
                    <div style="min-width:106px;">定位状态: {{item.locationStatus}}</div>
                    <div style="min-width:52px;">ACC: {{item.acc}}</div>
                    <div style="min-width:59px;">速度: {{item.speed}}</div>
                    <div :title="item.address">地址: {{showAddress(item.address)}}</div>
                </div>
            </div>
        </div>
        <el-table :data="data" id="out-table" border style="display:none;">
            <el-table-column prop="time" label="时间" />
            <el-table-column label="经度">
                <template slot-scope="{row}">
                    {{ row.point[0] }}
                </template>
            </el-table-column>
            <el-table-column label="纬度">
                <template slot-scope="{row}">
                    {{ row.point[1] }}
                </template>
            </el-table-column>
            <el-table-column label="设备状态">
                <template>
                    在线
                </template>
            </el-table-column>
            <el-table-column label="定位状态">
                <template slot-scope="{row}">
                    {{row.locationStatus}}
                </template>
            </el-table-column>
            <el-table-column prop="acc" label="ACC"/>
            <el-table-column prop="speed" label="速度" />
            <el-table-column label="地址">
                <template slot-scope="{row}">
                    {{showAddress(row.address)}}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'virtualList',
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        currentIndex: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            height: 240,
            rowHeight: 30,
            offset: 0,
            offsetIndex: 0,
            copyData: [],
        }
    },
    computed: {
        boxHeight() {
            return this.data.length * this.rowHeight;
        },
        offsetData() {
            let count = Math.ceil(this.height / this.rowHeight);
            let index = Math.floor(this.offset / this.rowHeight);
            this.offsetIndex = index;
            console.log('offsetData', this.data.slice(index, count + index))
            return this.data.slice(index, count + index)
        },

    },
    mounted() {
        // this.$refs.box.addEventListener('scroll', () => {
        //     console.log('this.$refs.box.scrollTop', this.$refs.box.scrollTop)
        //     this.offset = this.$refs.box.scrollTop;   
        // },false)
    },
    watch: {
        currentIndex(value){
            if(value >= 5 && value < this.data.length - 3){
               let offset = (value - 4) * this.rowHeight;
               this.$refs.box.scrollTop = offset;
               this.offset = offset;
            }else if(value < 5){
                this.$refs.box.scrollTop = 0;
               this.offset = 0;
            }
        }
    },
    methods: {
        toExport() {
            let excelName = '导出轨迹列表.xlsx';
            var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
            // 克隆节点
            let tables = document.getElementById("out-table").cloneNode(true);
            // 判断是否为固定列，解决（为固定列时，会重复生成表格）
            if (tables.querySelector('.el-table__fixed') !== null) {
                tables.removeChild(tables.querySelector('.el-table__fixed'))
            }
            let table_book = this.$XLSX.utils.table_to_book(tables,xlsxParam);
            var table_write = this.$XLSX.write(table_book, {
                bookType: "xlsx",
                bookSST: true,
                type: "array"
            });
            try {
                this.$FileSaver.saveAs(
                    new Blob([table_write], { type: "application/octet-stream" }),
                    excelName
                );
            } catch (e) {
                if (typeof console !== "undefined") console.log(e, table_write);
            }
            return table_write;
        },
        jumpNodeIndex(nodeIndex){
            this.$emit('jump', nodeIndex);
        },
        showAddress(v) {
            if(v.length > 33) {
                return v.substring(0,33) + "...";
            } else {
                return v;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.vl-box {
    width: 100%;
    overflow: hidden;
    background-color: rgba(0,0,0,0.6);
    color: #fff;
}
.vl-box > div {
    overflow: hidden;
    position: relative;
}
.vl-box > div > div {
    position: absolute;
    width: 100%;
}
.vl-box-item {
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    padding-left: 18px;
    cursor: pointer;
    display: flex;

    div{
        margin-right: 10px;
    }
}
.active_item{
    /* background-color: rgba(157,153,191,0.7); */
    background-color: rgba(223,231,41,0.3);
    color: #fff;
}
</style>